// components/features/subscriptions/SubscriptionsList.tsx

import { Subscription } from '../../../types/features/Subscription';
import TableList, { SelectAction } from '../../ui/TableList';
import SubscriptionRow from './SubscriptionRow';

interface SubscriptionsListProps {
  subscriptions: Subscription[];
  onAction: (subscription: Subscription) => void;
  onSelectSubscriptions?: (selectedSubscriptions: Subscription[]) => void;
  selectable?: boolean;
  selectActions?: SelectAction[];
}

export default function SubscriptionsList({
  subscriptions,
  onAction,
  onSelectSubscriptions,
  selectable = false,
  selectActions
}: SubscriptionsListProps) {
  const columns = [
    { header: "Entreprise", className: "w-1/4" },
    { header: "Plan", className: "w-1/6" },
    { header: "Statut", className: "hidden sm:table-cell w-1/6" },
    { header: "Sièges", className: "hidden md:table-cell w-1/6" },
    { header: "Prix", className: "hidden lg:table-cell w-1/6" },
    { header: "Expiration", className: "hidden xl:table-cell w-1/6" },
  ];

  return (
    <TableList
      items={subscriptions}
      columns={columns}
      getId={(subscription) => subscription.id}
      onAction={onAction}
      onSelectItems={onSelectSubscriptions}
      selectable={selectable}
      emptyMessage="Aucun abonnement trouvé"
      actionColumn={true}
      selectActions={selectActions}
      renderRow={(subscription, isSelected, onSelect) => (
        <SubscriptionRow
          key={subscription.id}
          subscription={subscription}
          onAction={onAction}
          onSelect={onSelect}
          isSelected={isSelected}
          selectable={selectable}
        />
      )}
    />
  );
}